import ImageGalleryEndcapBays from "./ImageGalleryEndcapBays";
export default ImageGalleryEndcapBays;
